import React from 'react';
import { CreateVersionPopup } from '.'; // ודא שהנתיב לקומפוננטה שיצרנו נכון

interface AdminAssessmentActionsProps {
    popups: Record<string, boolean>; // אובייקט המכיל את שמות הפופאפים והסטטוס שלהם
    setPopups: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;

    // Props שמועברים לפופאפ עצמו
    selectedTestsCount: number;
    handleCreateAll?: () => void;
    handleCreateSelected?: () => void;
}

const AdminAssessmentActions: React.FC<AdminAssessmentActionsProps> = ({
    popups,
    setPopups,
}) => {

    // פונקציה לטיפול בסגירת הפופאפ הספציפי הזה
    const handleCloseCreateVersion = (isOpen: boolean) => {
        setPopups(prev => ({ ...prev, createVersion: isOpen }));
    };

    return (
        <React.Fragment>

            {popups.createVersion && (
                <CreateVersionPopup
                    handleAlert={handleCloseCreateVersion}
                />
            )}


        </React.Fragment>
    );
}

export default AdminAssessmentActions;